module.exports = __webpack_public_path__ + "img/test_f.39c94749.png";